import { render, staticRenderFns } from "./UsageInternationalData.vue?vue&type=template&id=7d5c0ed3&scoped=true&"
import script from "./UsageInternationalData.vue?vue&type=script&lang=js&"
export * from "./UsageInternationalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5c0ed3",
  null
  
)

export default component.exports